exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1WAl-o4W1dMDfWA6FgTjZJ{background-color:#000;color:#fff}._2Mg0pOATQVp1xjkpz4yenF{font-size:18px}", ""]);

// exports
exports.locals = {
	"baseStyle": "_1WAl-o4W1dMDfWA6FgTjZJ",
	"someStyle": "_2Mg0pOATQVp1xjkpz4yenF _1WAl-o4W1dMDfWA6FgTjZJ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/postcss-loader!./src/styles/electrify-react.css
// module id = 131
// module chunks = 0